module.exports = __webpack_public_path__ + "account/img/112.268570b8.png";